<template>
  <component :is="$store.getters.isDesktop ? 'el-dialog' : 'el-drawer'" :visible.sync="visible" v-bind="options" class="recharge-gift-detail" :class="{ 'is-mobile': $store.getters.isMobile }">
    <div class="gift-detail__container">
      <div class="gift-detail__header">
        <div class="title">{{ $t('siteBuild.giftItems') }}</div>
        <div class="close" @click="close"><i class="el-icon-close" /></div>
      </div>
      <div v-if="limitText" class="gift-detail__limit">
        <div class="label">Limit：</div>
        <div class="value">
          {{ limitText }}
        </div>
      </div>
      <div class="gift-detail__list" :class="{ 'animate': animated }">
        <Skeleton v-if="loading" class="px-4" :rows="4" :avatar="true" />
        <template v-else>
          <div v-for="(item, idx) in giftList" :key="idx" class="gift-detail__row" :style="{ animationDelay: (idx * 100) + 'ms' }">
            <img :src="item.gift_goods_logo" alt="" class="icon" />
            <div class="name">{{ getName(item) }}</div>
            <div class="num">x {{ item.num}}</div>
          </div>
          <div v-if="giftList.length === 0" class="gift-detail__empty">{{ $t('siteBuild.shopCart.noData') }}</div>
        </template>
      </div>
    </div>
  </component>
</template>

<script>
import { Dialog, Drawer, Message } from 'element-ui'
import Skeleton from '@/components/common/Skeleton.vue'
import { getLangIdI18n } from '~/utils';
export default {
  name: 'RechargeGiftDetail',
  components: { [Dialog.name]: Dialog, [Drawer.name]: Drawer, Skeleton },
  props: {
   data: Object,
   amount: [String, Number]
  },
  data() {
    return {
      visible: false,
      animated: false,
      loading: false,
      anyValueGiftList: []
    }
  },
  computed: {
    options() {
      if (this.$store.getters.isDesktop) {
        return { width: '560px', appendToBody: false, destroyOnClose: false, showClose: false }
      } else {
        return { direction: 'btt', size: 'auto', appendToBody: false, withHeader: false, showClose: false, destroyOnClose: false }
      }
    },
    limitText() {
      const use = this.data?.limited_bonus_per_person_consumed
      const toatl = this.data?.limited_bonus_per_person
      if ((toatl - use) > 0) {
        return `${use} / ${toatl}`
      } else {
        return false
      }
    },
    giftList() {
      return this.isAny ? this.anyValueGiftList : (this.data?.gifts || [])
    },
    isAny() {
      return this.data.type === 2
    }
  },
  methods: {
    open() {
      this.visible = true
      this.anyValueGiftList = []
      this.animated = false
      this.getGiftsByAmount()
      this.$nextTick(() => {
        this.animated = true
      })
    },
    close() {
      this.visible = false
      this.animated = false
    },
    async getGiftsByAmount() {
      const isAny = this.data.type === 2
      const amount = Number(String(this.amount)?.replaceAll(',', '')?.replaceAll('.', ''))
      const { recharge_id, currency } = this.data
      if (isAny && amount) {
        this.loading = true
        const params = {
          recharge_id,
          currency,
          price: amount
        }
        const [err, res] = await this.$utils.to(this.$api.recharge.calculateBonus(params))
        if (err) {
          Message.error(err)
          return
        }
        this.anyValueGiftList = res?.data || []
        this.loading = false
      } else {
        this.loading = false
      }
    },
    getName(item) {
      return getLangIdI18n({ lang_id: item.gift_goods_name }, this.$store.state.locale.langIdData)
    }
  }
}
</script>

<style lang="less">
.recharge-gift-detail {
  .el-dialog {
    border-radius: 4px;
    overflow: hidden;
  }
  .el-drawer {
    border-radius: 4px 4px 0 0;
    overflow: hidden;
  }
  .gift-detail__container {
    background: white;
    color: #333;
    position: relative;
  }
  .el-dialog__header { display: none; }
  .el-dialog__body { padding: 0; }

  .gift-detail__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    .title { font-size: 18px; font-weight: bold; }
    .close { cursor: pointer; font-size: 20px; }
  }

  .gift-detail__limit {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f3f3f3;
    color: #333;
    padding: 12px 16px;
    .label { font-weight: 500; }
    .value { font-weight: 500; }
  }

  .gift-detail__list {
    padding: 8px 0;
  }

  .gift-detail__row {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #eee;
    .icon { width: 40px; height: 40px; object-fit: contain; margin-right: 12px; }
    .name { flex: 1; }
    .num { color: #333; }
  }

  .gift-detail__empty {
    padding: 24px 16px;
    text-align: center;
    color: #999;
  }

  /* 顺序入场动画 */
  .gift-detail__list.animate .gift-detail__row {
    opacity: 0;
    transform: translateY(6px);
    animation: giftRowIn .36s ease-out forwards;
  }
  @keyframes giftRowIn {
    from { opacity: 0; transform: translateY(6px); }
    to { opacity: 1; transform: translateY(0); }
  }

  .el-drawer__body {
    padding: 0;
  }
}
</style>